import GetLoading from "../../share/getLoading";
 import React, { useEffect, useState, useRef } from "react";
import {
  SendOutlined,
  PlusCircleOutlined,
  HistoryOutlined,
  UserOutlined,
  SearchOutlined,
  DeleteOutlined,
  ReloadOutlined,
  CheckCircleOutlined,
  CloseCircleOutlined,
  ClockCircleOutlined,
  TeamOutlined,
  MessageOutlined,
  MessageFilled,
  UploadOutlined,
} from "@ant-design/icons";
import {
  Modal,
  message,
  Button,
  Form,
  Input,
  Select,
  Space,
  Tag,
  Checkbox,
  Spin,
  Popconfirm,
  DatePicker,
  Pagination,
  Avatar,
  Badge,
  Table,
  Tabs,
  Tooltip,
  notification,
} from "antd";
import "../../styles/Home-module.css";
import styles from "../../styles/Font.css";
import { request } from "../../share/request";
import { Stack } from "react-bootstrap";
import { openNotification } from "../../share/message";
import { getPermission, getCurrentUser } from "../../share/getProfile";
import {
  formateDateClient,
  formateDateSystem,
  linkPath,
} from "../../share/helper";
import { MdOutlineEdit, MdOutlineDelete, MdSend } from "react-icons/md";
import { BsDownload, BsTelegram } from "react-icons/bs";
import { BiCheckDouble, BiMessageDetail } from "react-icons/bi";
import { HiOutlineDownload } from "react-icons/hi";
import { boxHeader, boxHeaderTagText } from "../../styles/boxShadow";
import DepartmentList from "../../component/list/DepartmentList";
import Upload from "antd/es/upload/Upload";
 
const { Option } = Select;
const { TextArea } = Input;
const { TabPane } = Tabs;

const SendMessageTelegram = () => {
  const getProfileOrg = getCurrentUser();

  const itemsPerPage = 10;
const [objFilter, setObjFilter] = useState({
    page: 1,
    itemPerPage: itemsPerPage,
    txtSearch: "",
    telegram_status: 'all', // 'all', 'connected', 'not_connected' - DEFAULT TO ALL
    department_id: '',
});
// Add state for telegram filter
const [telegramFilter, setTelegramFilter] = useState('all');


  // States
  const [listUsers, setListUsers] = useState([]);
  const [listMessages, setListMessages] = useState([]);
 
  const [messageText, setMessageText] = useState("");
  const [messageType, setMessageType] = useState("text");
  const [loading, setLoading] = useState(true);
  const [loadingSpin, setLoadingSpin] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [total_item, setTotalItem] = useState(0);
  const [visableNewModel, setVisableNewModel] = useState(false);
  const [visableHistoryModel, setVisableHistoryModel] = useState(false);
  const [activeTab, setActiveTab] = useState("compose");
  const [selectedDepartments, setSelectedDepartments] = useState([]); // Department filter state

  // Permission
  const userPermission = getPermission();
  const telegramPageValue = userPermission.find(
    (permission) => permission.pagename === "telegrammessage"
  ) || { add: 1, edit: 0, deleted: 0, print: 0 };

  const {
    add: addvalue,
    edit: Editvalue,
    deleted: deletevalue,
    print: printValue,
  } = telegramPageValue;


  // Add state for stats
const [stats, setStats] = useState({
    total_all: 0,
    total_connected: 0,
    total_not_connected: 0
});


  // In SendMessageTelegram.js

 
// Update getListUsers to capture stats
const getListUsers = async (objFilter) => {
    const param = new URLSearchParams({
        page: objFilter.page,
        itemPerPage: itemsPerPage,
        txtSearch: objFilter.txtSearch,
        telegram_status: objFilter.telegram_status || 'all',
        org_code: getProfileOrg.org_code,
    });

    if (objFilter.department_id) {
        param.append("department_id", objFilter.department_id);
    }

    try {
        setLoading(true);
        await new Promise((resolve) => setTimeout(resolve, 400));
        const res = await request("telegramusers?" + param.toString(), "get", {});
        
        console.log("API Response:", res);
        
        if (res) {
            let userList = [];
            let totalCount = 0;

            if (res.list && Array.isArray(res.list)) {
                userList = res.list;
                totalCount = res.total || res.list.length;
            } else if (Array.isArray(res)) {
                userList = res;
                totalCount = res.length;
            }

            setListUsers(userList);
            setTotalItem(totalCount);
            
            // SET STATS
            if (res.stats) {
                setStats(res.stats);
            }
        } else {
            setListUsers([]);
            setTotalItem(0);
            setStats({ total_all: 0, total_connected: 0, total_not_connected: 0 });
        }
    } catch (error) {
        console.error("Error fetching users:", error);
        setListUsers([]);
        setTotalItem(0);
        setStats({ total_all: 0, total_connected: 0, total_not_connected: 0 });
    } finally {
        setLoading(false);
    }
};
  // Fetch message history
  const getMessageHistory = async () => {
    try {
      setLoadingSpin(true);
      const res = await request("telegrammessages", "get", {
        org_code: getProfileOrg.org_code,
      });

      if (res) {
        if (res.list && Array.isArray(res.list)) {
          setListMessages(res.list);
        } else if (Array.isArray(res)) {
          setListMessages(res);
        } else {
          setListMessages([]);
        }
      } else {
        setListMessages([]);
      }
    } catch (error) {
      console.error("Error fetching messages:", error);
      setListMessages([]);
    } finally {
      setLoadingSpin(false);
    }
  };

  useEffect(() => {
    getListUsers(objFilter);
    getMessageHistory();
  }, []);
// Add these imports
 
// Add state for image
const [imageFile, setImageFile] = useState(null);
const [imagePreview, setImagePreview] = useState(null);

// Handle image upload
const handleImageUpload = (file) => {
    setImageFile(file);
    
    // Create preview
    const reader = new FileReader();
    reader.onload = (e) => {
        setImagePreview(e.target.result);
    };
    reader.readAsDataURL(file);
    
    return false; // Prevent automatic upload
};

// Remove image
const handleRemoveImage = () => {
    setImageFile(null);
    setImagePreview(null);
};
  // Handle department change
  const handleDepartmentChange = (selectedDepts) => {
    setSelectedDepartments(selectedDepts || []);
    setCurrentPage(1);
    
    // Pass single department or comma-separated for multiple
    const departmentId = selectedDepts.length > 0 ? selectedDepts.join(',') : '';
    
    const objTem = {
      ...objFilter,
      page: 1,
      department_id: departmentId,
    };
    setObjFilter(objTem);
    getListUsers(objTem);
  };

  // After your state declarations, add localStorage key constant
const STORAGE_KEY = 'telegram_selected_users';

 // Update your state initialization to load from localStorage
const [selectedUsers, setSelectedUsers] = useState(() => {
  try {
    const saved = localStorage.getItem(STORAGE_KEY);
    return saved ? JSON.parse(saved) : [];
  } catch (error) {
    console.error("Error loading selected users from localStorage:", error);
    return [];
  }
});

// Add a useEffect to save to localStorage whenever selectedUsers changes
useEffect(() => {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(selectedUsers));
  } catch (error) {
    console.error("Error saving selected users to localStorage:", error);
  }
}, [selectedUsers]);


 
 
 // Update handleSelectAll to save full user objects (not just IDs)
const handleSelectAll = (checked) => {
  const usersArray = Array.isArray(listUsers) ? listUsers : [];
  const currentPageUsers = usersArray.filter((user) => user.telegram_chat_id);
  
  if (checked) {
    setSelectedUsers(prev => {
      // Get users from other pages (keep their full objects if they exist, or IDs)
      const otherPageSelections = prev.filter(
        item => {
          const itemId = typeof item === 'object' ? item.telegram_chat_id : item;
          return !currentPageUsers.some(cp => cp.telegram_chat_id === itemId);
        }
      );
      
      // Combine with current page users (full objects)
      const newSelection = [...otherPageSelections, ...currentPageUsers];
      
      // Remove duplicates by telegram_chat_id
      const uniqueSelection = newSelection.filter((item, index, self) => {
        const itemId = typeof item === 'object' ? item.telegram_chat_id : item;
        return index === self.findIndex(u => {
          const uId = typeof u === 'object' ? u.telegram_chat_id : u;
          return uId === itemId;
        });
      });
      
      return uniqueSelection;
    });
  } else {
    // Remove current page users from selection
    const currentPageUserIds = currentPageUsers.map(u => u.telegram_chat_id);
    setSelectedUsers(prev => 
      prev.filter(item => {
        const itemId = typeof item === 'object' ? item.telegram_chat_id : item;
        return !currentPageUserIds.includes(itemId);
      })
    );
  }
};

// Update handleSelectUser to save full user object
const handleSelectUser = (telegram_chat_id, checked) => {
  const usersArray = Array.isArray(listUsers) ? listUsers : [];
  
  if (checked) {
    const userToAdd = usersArray.find(u => u.telegram_chat_id === telegram_chat_id);
    if (userToAdd) {
      setSelectedUsers(prev => {
        // Check if user already exists (avoid duplicates)
        const exists = prev.some(item => {
          const itemId = typeof item === 'object' ? item.telegram_chat_id : item;
          return itemId === telegram_chat_id;
        });
        
        if (exists) {
          return prev;
        }
        return [...prev, userToAdd];
      });
    }
  } else {
    setSelectedUsers(prev => 
      prev.filter(item => {
        const itemId = typeof item === 'object' ? item.telegram_chat_id : item;
        return itemId !== telegram_chat_id;
      })
    );
  }
};

// Add a helper function to get user ID whether it's an object or string
const getUserId = (item) => {
  return typeof item === 'object' ? item.telegram_chat_id : item;
};

// Add a helper function to get user display info
const getUserInfo = (item) => {
  if (typeof item === 'object') {
    return item;
  }
  // If it's just a string ID, try to find in current page
  return usersArray.find(u => u.telegram_chat_id === item) || null;
};


// Add a function to clear all selections (useful after sending messages)
const clearAllSelections = () => {
  setSelectedUsers([]);
  localStorage.removeItem(STORAGE_KEY);
};
  
 const onSendMessage = async () => {
    if (selectedUsers.length === 0) {
        openNotification("warning", "Warning", "សូមជ្រើសរើសអ្នកទទួលសារ");
        return;
    }
    if (messageType === 'media' && uploadedFiles.length === 0 && !messageText.trim()) {
        openNotification("warning", "Warning", "សូមបញ្ចូលឯកសារ ឬ អត្ថបទ");
        return;
    }
    if (messageType === 'text' && !messageText.trim()) {
        openNotification("warning", "Warning", "សូមបញ្ចូលសារ");
        return;
    }

    Modal.confirm({
        title: (
            <span style={{ fontFamily: 'Content', fontSize: 16, fontWeight: 'bold' }}>
                បញ្ជាក់ការផ្ញើសារ
            </span>
        ),
        content: (
            <span style={{ fontFamily: 'Content', fontSize: 14 }}>
                តើអ្នកចង់ផ្ញើសារទៅកាន់អ្នកទទួលចំនួន{' '}
                <strong style={{ color: '#1890ff', fontSize: 16 }}>{selectedUsers.length}</strong>
                {' '}នាក់មែនទេ?
                {uploadedFiles.length > 0 && (
                    <span> (ជាមួយឯកសារ {uploadedFiles.length} ឯកសារ)</span>
                )}
            </span>
        ),
        okText: <span style={{ fontFamily: 'Content', padding: '0 8px' }}>ផ្ញើ</span>,
        cancelText: <span style={{ fontFamily: 'Content', padding: '0 8px' }}>បោះបង់</span>,
        onOk: async () => {
            setLoadingSpin(true);
            try {
                const formData = new FormData();
                
                // Extract only telegram_chat_id array from selectedUsers (handles both objects and strings)
                const recipientIds = selectedUsers.map(item => 
                    typeof item === 'object' ? item.telegram_chat_id : item
                );
                
                // Send only the array of telegram_chat_id strings
                formData.append('recipients', JSON.stringify(recipientIds));
                formData.append('message_text', messageText || '');
                formData.append('message_type', messageType);
                formData.append('org_code', getProfileOrg.org_code);
                
                // Append all files (images + documents)
                uploadedFiles.forEach((item) => {
                    formData.append('files', item.file);
                });
                
                const res = await request("telegrammessages/send", "post", formData, {
                    headers: { 'Content-Type': 'multipart/form-data' }
                });
                
                if (res && res.success) {
                    openNotification("success", "Success", "ផ្ញើសារដោយជោគជ័យ");
                    setMessageText("");
                    setSelectedUsers([]);
                    handleRemoveAllFiles();
                    clearAllSelections(); // Clear selections after successful send
                    setMessageType('text');
                    getMessageHistory();
                }
            } catch (error) {
                openNotification("error", "Error", "Failed to send message");
            } finally {
                setLoadingSpin(false);
            }
        },
    });
};


// Add a new function to select all active telegram users across all pages
const handleSelectAllActiveUsers = async () => {
  try {
    setLoadingSpin(true);
    
    // Fetch all active telegram users (no pagination, only connected)
    const param = new URLSearchParams({
      page: 1,
      itemPerPage: 999999, // Large number to get all
      txtSearch: objFilter.txtSearch,
      telegram_status: 'connected', // Only connected users
      org_code: getProfileOrg.org_code,
    });

    if (objFilter.department_id) {
      param.append("department_id", objFilter.department_id);
    }

    const res = await request("telegramusers?" + param.toString(), "get", {});
    
    if (res) {
      let allActiveUsers = [];
      
      if (res.list && Array.isArray(res.list)) {
        allActiveUsers = res.list;
      } else if (Array.isArray(res)) {
        allActiveUsers = res;
      }
      
      // Save all active users to state and localStorage
      setSelectedUsers(allActiveUsers);
      
      openNotification(
        "success", 
        "Success", 
        `បានជ្រើសរើសអ្នកប្រើប្រាស់ដែលមាន Telegram ទាំងអស់ចំនួន ${allActiveUsers.length} នាក់`
      );
    }
  } catch (error) {
    console.error("Error fetching all active users:", error);
    openNotification("error", "Error", "មិនអាចទាញយកទិន្នន័យអ្នកប្រើប្រាស់បានទេ");
  } finally {
    setLoadingSpin(false);
  }
};

// Optional: If you want to select all users (both connected and not connected)
const handleSelectAllUsers = async () => {
  try {
    setLoadingSpin(true);
    
    // Fetch all users (no pagination)
    const param = new URLSearchParams({
      page: 1,
      itemPerPage: 999999, // Large number to get all
      txtSearch: objFilter.txtSearch,
      telegram_status: 'all', // All users
      org_code: getProfileOrg.org_code,
    });

    if (objFilter.department_id) {
      param.append("department_id", objFilter.department_id);
    }

    const res = await request("telegramusers?" + param.toString(), "get", {});
    
    if (res) {
      let allUsers = [];
      
      if (res.list && Array.isArray(res.list)) {
        allUsers = res.list.filter(user => user.telegram_chat_id); // Only users with telegram
      } else if (Array.isArray(res)) {
        allUsers = res.filter(user => user.telegram_chat_id); // Only users with telegram
      }
      
      // Save all users to state and localStorage
      setSelectedUsers(allUsers);
      
      openNotification(
        "success", 
        "Success", 
        `បានជ្រើសរើសអ្នកប្រើប្រាស់ទាំងអស់ចំនួន ${allUsers.length} នាក់`
      );
    }
  } catch (error) {
    console.error("Error fetching all users:", error);
    openNotification("error", "Error", "មិនអាចទាញយកទិន្នន័យអ្នកប្រើប្រាស់បានទេ");
  } finally {
    setLoadingSpin(false);
  }
};
  // Resend failed message
  const onResendMessage = async (messageId) => {
    setLoadingSpin(true);
    try {
      const res = await request(
        `telegrammessages/resend/${messageId}`,
        "post",
        {}
      );
      if (res) {
        openNotification("success", "Success", "Message resent successfully");
        getMessageHistory();
      }
    } catch (error) {
      openNotification("error", "Error", "Failed to resend message");
    } finally {
      setLoadingSpin(false);
    }
  };

  // Delete message
  const onDeleteMessage = async (messageId) => {
    setLoadingSpin(true);
    try {
      const res = await request(`telegrammessages/${messageId}`, "delete", {});
      if (res) {
        openNotification("success", "Success", "Message deleted successfully");
        getMessageHistory();
      }
    } catch (error) {
      openNotification("error", "Error", "Failed to delete message");
    } finally {
      setLoadingSpin(false);
    }
  };
// Replace old image states with:
const [uploadedFiles, setUploadedFiles] = useState([]); // Array of { file, preview, name, size, extension, isImage }

// Get file extension
const getFileExtension = (filename) => {
    const parts = filename.split('.');
    return parts.length > 1 ? parts.pop().toUpperCase() : '';
};

// Check if file is image
const isImageFile = (file) => {
    return file.type.startsWith('image/');
};

// Format file size
const formatFileSize = (bytes) => {
    if (bytes < 1024) return bytes + ' B';
    if (bytes < 1024 * 1024) return (bytes / 1024).toFixed(1) + ' KB';
    return (bytes / (1024 * 1024)).toFixed(1) + ' MB';
};

// Get color based on file extension
const getFileColor = (ext) => {
    const colors = {
        'PDF': '#e74c3c',
        'DOC': '#2980b9',
        'DOCX': '#2980b9',
        'PPT': '#e67e22',
        'PPTX': '#e67e22',
        'XLS': '#27ae60',
        'XLSX': '#27ae60',
        'TXT': '#7f8c8d',
        'CSV': '#27ae60',
        'ZIP': '#8e44ad',
        'RAR': '#8e44ad',
    };
    return colors[ext] || '#607D8B';
};

// Handle file upload (images + documents)
const handleFileUpload = (file) => {
    // Check max files
    if (uploadedFiles.length >= 10) {
        openNotification("warning", "Warning", "អតិបរមា 10 ឯកសារ");
        return false;
    }
    
    // Check file size (max 10MB per file)
    const maxSize = 10 * 1024 * 1024; // 10MB
    if (file.size > maxSize) {
        openNotification("warning", "Warning", `ឯកសារ "${file.name}" ធំជាង 10MB`);
        return false;
    }
    
    const ext = getFileExtension(file.name);
    const isImage = isImageFile(file);
    
    if (isImage) {
        // Create preview for images
        const reader = new FileReader();
        reader.onload = (e) => {
            setUploadedFiles(prev => [...prev, {
                file: file,
                preview: e.target.result,
                name: file.name,
                size: file.size,
                extension: ext,
                isImage: true
            }]);
        };
        reader.readAsDataURL(file);
    } else {
        // No preview for documents
        setUploadedFiles(prev => [...prev, {
            file: file,
            preview: null,
            name: file.name,
            size: file.size,
            extension: ext,
            isImage: false
        }]);
    }
    
    return false; // Prevent automatic upload
};

// Remove single file by index
const handleRemoveFile = (index) => {
    setUploadedFiles(prev => prev.filter((_, i) => i !== index));
};

// Remove all files
const handleRemoveAllFiles = () => {
    setUploadedFiles([]);
};
  // Handle page change
  const handlePageChange = async (pageNumber) => {
    setCurrentPage(pageNumber);
    const objTem = { ...objFilter, page: pageNumber };
    setObjFilter(objTem);
    getListUsers(objTem);
  };

  // Handle search
  const onChangeSearch = (e) => {
    const KeyWork_Search = e.target.value;
    setCurrentPage(1);
    const objTemSearch = { ...objFilter, txtSearch: KeyWork_Search, page: 1 };
    setObjFilter(objTemSearch);
    getListUsers(objTemSearch);
  };

  // Get status tag
  const getStatusTag = (status) => {
    const statusMap = {
      sent: { color: "success", icon: <CheckCircleOutlined />, text: "ជោគជ័យ" },
      pending: {
        color: "processing",
        icon: <ClockCircleOutlined />,
        text: "កំពុងរងចាំ",
      },
      failed: {
        color: "error",
        icon: <CloseCircleOutlined />,
        text: "បរាជ័យ",
      },
    };
    const config = statusMap[status] || statusMap.pending;
    return (
      <Tag color={config.color} icon={config.icon}>
        {config.text}
      </Tag>
    );
  };
 
 const messageColumns = [
    { 
        title: "ល.រ", 
        dataIndex: "id", 
        key: "id", 
        width: 50, 
        render: (text, record, index) => index + 1 
    },
    { 
        title: "កាលបរិច្ឆេទ", 
        dataIndex: "created_at", 
        key: "created_at", 
        width: 140, 
        render: (date) => formateDateClient(date)
    },
    { 
        title: "អ្នកទទួល", 
        key: "recipients_info", 
        width: 200,
        render: (text, record) => {
            const recipients = record.recipients || [];
            const firstRecipient = recipients[0];
            const remaining = recipients.length - 1;
            
            return (
                <Space>
                    <Avatar
                        size={35}
                        src={firstRecipient?.image ? `${linkPath}${firstRecipient.image}` : undefined}
                        icon={!firstRecipient?.image && <UserOutlined />}
                        style={{ 
                            backgroundColor: '#0088cc',
                            flexShrink: 0
                        }}
                    />
                    <div style={{ display: 'flex', flexDirection: 'column', minWidth: 0 }}>
                        <span style={{ fontFamily: 'Content', fontWeight: 'bold', fontSize: 13 }}>
                            {firstRecipient?.fullname || 'Unknown'}
                        </span>
                        <span style={{ fontSize: 11, color: '#888' }}>
                            {firstRecipient?.phone || firstRecipient?.chat_id || ''}
                        </span>
                        {remaining > 0 && (
                            <Tag color="blue" style={{ fontSize: 10, padding: '0 6px', marginTop: 2 }}>
                                +{remaining} នាក់ទៀត
                            </Tag>
                        )}
                    </div>
                </Space>
            );
        }
    },
    { 
        title: "ចំនួន", 
        key: "count", 
        width: 70,
        align: 'center',
        render: (text, record) => (
            <Tag color="blue" style={{ fontFamily: 'Content' }}>
                {record.total_recipients || record.recipients_count || 0}
            </Tag>
        )
    },
    { 
        title: "សារ", 
        dataIndex: "message_text", 
        key: "message_text", 
        ellipsis: true, 
        render: (text) => (
            <Tooltip title={text}>
                <div style={{ maxWidth: 250, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                    {text}
                </div>
            </Tooltip>
        )
    },
    { 
        title: "ស្ថានភាព", 
        dataIndex: "status", 
        key: "status", 
        width: 100, 
        render: (status, record) => {
            if (status === 'partial') {
                return (
                    <Tag color="warning" style={{ fontFamily: 'Content' }}>
                        ✅{record.success_count}/❌{record.failed_count}
                    </Tag>
                );
            }
            return getStatusTag(status);
        }
    },
    { 
        title: "សកម្មភាព", 
        key: "action", 
        width: 80, 
        render: (text, record) => (
            <Space>
                {(record.status === "failed" || record.status === "partial") && (
                    <Tooltip title="ផ្ញើសារម្តងទៀត">
                        <Button type="primary" size="small" icon={<ReloadOutlined />} onClick={() => onResendMessage(record.id)} />
                    </Tooltip>
                )}
                <Tooltip title="លុប">
                    <Button type="primary" danger size="small" icon={<DeleteOutlined />} onClick={() => onDeleteMessage(record.id)} />
                </Tooltip>
            </Space>
        )
    },
]; 
  // Safe computation for summary cards
  const usersArray = Array.isArray(listUsers) ? listUsers : [];
  const messagesArray = Array.isArray(listMessages) ? listMessages : [];
  const sentCount = messagesArray.filter((m) => m.status === "sent").length;
  const failedCount = messagesArray.filter((m) => m.status === "failed").length;

  return (
    <div>
      {/* Loading Overlay */}
      <div className="sprinSave-container">
        {loadingSpin && (
          <div className="sprinSave">
            <GetLoading />
          </div>
        )}
      </div>

      {/* Header */}
      <div style={boxHeader}>
        <div style={{ display: "flex", justifyItems: "center", width: "auto", flexWrap: "wrap", gap: "8px" }}>
          <Space wrap>
            {boxHeaderTagText("ផ្ញើសារតាម Telegram")}
            
            {/* Search Input */}
            <Input
              style={{ width: 200 }}
              onChange={onChangeSearch}
              className="styleTageStatusForm"
              placeholder="ស្វែងរកអ្នកប្រើប្រាស់..."
              allowClear
              prefix={<SearchOutlined />}
            />
            
            {/* Department Filter - ADDED HERE */}
            <div style={{ minWidth: 220 }}>
              <DepartmentList
                selectedDepartments={selectedDepartments}
                onChange={handleDepartmentChange}
                placeholder="ជ្រើសរើសនាយកដ្ឋាន..."
                multiple={true}
                allowClear={true}
                showSelectAll={true}
                maxTagCount={2}
              />
            </div>
          </Space>
        </div>
        
        <div>
          <Space>
            <Button
                
              className="buttonstylekhmer"
              onClick={() => setVisableHistoryModel(true)}
              type="default"
              style={{color:'#fff'}}
              icon={<HistoryOutlined />}
            >
              ប្រវត្តិសារ
            </Button>
            <Button
              onClick={() => setVisableNewModel(true)}
              disabled={!addvalue}
              className="custom-form-item"
              type="primary"
              icon={<PlusCircleOutlined />}
            >
              ផ្ញើសារថ្មី
            </Button>
          </Space>
        </div>
      </div>

      {/* Main Content */}
      <div style={{ padding: "16px", background: "#fff", borderRadius: "8px", marginTop: "16px" }}>
        {loading ? (
          <div className="sprinCustome">
            <GetLoading />
          </div>
        ) : (
          <>
            {/* Summary Cards */}
            {/* Summary Cards */}
<div style={{ display: "flex", gap: "16px", marginBottom: "24px", flexWrap: "wrap" }}>
  {/* Total Users */}
  <div style={{ flex: 1, minWidth: 200, padding: "16px", background: "#f0f5ff", borderRadius: "8px", border: "1px solid #d6e4ff" }}>
    <Space>
      <TeamOutlined style={{ fontSize: 24, color: "#1890ff" }} />
      <div>
        <div style={{ fontSize: 12, color: "#888", fontFamily: 'Content' }}>អ្នកប្រើប្រាស់សរុប</div>
        <div style={{ fontSize: 24, fontWeight: "bold", color: "#1890ff" }}>
          {stats.total_all}
        </div>
      </div>
    </Space>
  </div>
  
  {/* Connected Users */}
  <div style={{ flex: 1, minWidth: 200, padding: "16px", background: "#f6ffed", borderRadius: "8px", border: "1px solid #b7eb8f" }}>
    <Space>
      <CheckCircleOutlined style={{ fontSize: 24, color: "#52c41a" }} />
      <div>
        <div style={{ fontSize: 12, color: "#888", fontFamily: 'Content' }}>បានភ្ជាប់ Telegram</div>
        <div style={{ fontSize: 24, fontWeight: "bold", color: "#52c41a" }}>
          {stats.total_connected}
        </div>
      </div>
    </Space>
  </div>
  
  {/* Not Connected Users */}
  <div style={{ flex: 1, minWidth: 200, padding: "16px", background: "#fff7e6", borderRadius: "8px", border: "1px solid #ffd591" }}>
    <Space>
      <ClockCircleOutlined style={{ fontSize: 24, color: "#faad14" }} />
      <div>
        <div style={{ fontSize: 12, color: "#888", fontFamily: 'Content' }}>មិនទាន់ភ្ជាប់</div>
        <div style={{ fontSize: 24, fontWeight: "bold", color: "#faad14" }}>
          {stats.total_not_connected}
        </div>
      </div>
    </Space>
  </div>
</div>

 
 
{/* Filter Tabs - All / Connected / Not Connected */}
<div style={{ 
    marginBottom: "16px", 
    display: "flex", 
    justifyContent: "space-between", 
    alignItems: "center",
    flexWrap: "wrap",
    gap: "8px"
}}>
    <Space>
       <Space size={8}>
    <Button 
        type={telegramFilter === 'all' ? 'primary' : 'default'}
       
        size="small"
        style={{ padding: '2px 16px' , height:30, }}
        onClick={() => {
            setTelegramFilter('all');
            setCurrentPage(1);
            const objTem = { ...objFilter, telegram_status: 'all', page: 1 };
            setObjFilter(objTem);
            getListUsers(objTem);
        }}
    >
        ទាំងអស់ ({stats.total_all || total_item})
    </Button>
    
    <Button 
        type={telegramFilter === 'connected' ? 'primary' : 'default'}
      
        size="small"
        style={{ 
             height:30,
            padding: '2px 16px',
            backgroundColor: telegramFilter === 'connected' ? '#52c41a' : '#f6ffed',
            borderColor: '#52c41a', 
            color: telegramFilter === 'connected' ? '#fff' : '#52c41a',
        }}
        onClick={() => {
            setTelegramFilter('connected');
            setCurrentPage(1);
            const objTem = { ...objFilter, telegram_status: 'connected', page: 1 };
            setObjFilter(objTem);
            getListUsers(objTem);
        }}
    >
        <CheckCircleOutlined style={{ marginRight: 4 }} />
        បានភ្ជាប់ ({stats.total_connected || 0})
    </Button>
    
    <Button 
        type={telegramFilter === 'not_connected' ? 'primary' : 'default'}
      
        size="small"
        style={{ 
            height:30,
            padding: '2px 16px',
            backgroundColor: telegramFilter === 'not_connected' ? '#faad14' : '#fffbe6',
            borderColor: '#faad14', 
            color: telegramFilter === 'not_connected' ? '#fff' : '#faad14',
        }}
        onClick={() => {
            setTelegramFilter('not_connected');
            setCurrentPage(1);
            const objTem = { ...objFilter, telegram_status: 'not_connected', page: 1 };
            setObjFilter(objTem);
            getListUsers(objTem);
        }}
    >
        <ClockCircleOutlined style={{ marginRight: 4 }} />
        មិនទាន់ភ្ជាប់ ({stats.total_not_connected || 0})
    </Button>
</Space>
    </Space>
    {/* Users Table Section Header */}
 {/* Users Table Section Header */}
<div style={{ 
    display: "flex", 
    justifyContent: "space-between", 
    alignItems: "center", 
    marginBottom: "12px",
    flexWrap: "wrap",
    gap: "8px"
}}>
    <Space wrap>
            {/* Button to select ALL active telegram users */}
        <Button
            type="default"
            size="small"
            
            icon={<CheckCircleOutlined />}
            onClick={handleSelectAllActiveUsers}
            style={{ 
                fontFamily: 'Content',
                borderColor: '#52c41a',
                color: '#1a5502ff',
                height:35,
                backgroundColor:'#39f70e2a'

            }}
        >
            ជ្រើសរើសទាំងអស់បានភ្ជាប់ Telegram
        </Button>
        {/* Checkbox for current page */}
        <Checkbox
            style={{fontFamily:'Content'}}
            onChange={(e) => handleSelectAll(e.target.checked)}
            checked={
                usersArray.filter((u) => u.telegram_chat_id).length > 0 &&
                usersArray
                    .filter((u) => u.telegram_chat_id)
                    .every((u) => 
                        selectedUsers.some(su => getUserId(su) === u.telegram_chat_id)
                    )
            }
            indeterminate={
                usersArray
                    .filter((u) => u.telegram_chat_id)
                    .some((u) => 
                        selectedUsers.some(su => getUserId(su) === u.telegram_chat_id)
                    ) &&
                !usersArray
                    .filter((u) => u.telegram_chat_id)
                    .every((u) => 
                        selectedUsers.some(su => getUserId(su) === u.telegram_chat_id)
                    )
            }
        >
            ជ្រើសរើសទំព័រនេះ
        </Checkbox>

    

        {/* Clear all selections */}
        {selectedUsers.length > 0 && (
            <Button
                type="link"
                size="small"
                danger
                onClick={clearAllSelections}
                style={{ fontFamily: 'Content' }}
            >
                សម្អាតទាំងអស់ ({selectedUsers.length})
            </Button>
        )}
    </Space>

    {/* Send message button */}
    <Space>
        {selectedUsers.length > 0 && (
            <Button
                type="primary"
                icon={<SendOutlined />}
                onClick={() => setVisableNewModel(true)}
                size="large"
            >
                ផ្ញើសារ ({selectedUsers.length})
            </Button>
        )}
    </Space>
</div> 
</div>
            {/* Users Table */}
            <table className="table table-striped table-hover rounded-table" style={{ width: "100%" }}>
              <thead>
                <tr className="table-success">
                  <th style={{ width: 50 }}>#</th>
                  <th style={{ width: 50 }}>ជ្រើស</th>
                  <th>ឈ្មោះ</th>
                  <th>លេខទូរស័ព្ទ</th>
                  <th>ប្រភេទបុគ្គលិក</th>
                  <th>ផ្នែក</th>
                  <th>Telegram ID</th>
                  <th>ស្ថានភាព</th>
                </tr>
              </thead>
             <tbody>
    {usersArray.map((user, index) => (
        <tr key={user.id || index} className="table-Secondary">
            <td>{index + 1 + (currentPage - 1) * itemsPerPage}</td>
            <td>
             <Checkbox
                    checked={selectedUsers.some(su => getUserId(su) === user.telegram_chat_id)}
                    onChange={(e) => handleSelectUser(user.telegram_chat_id, e.target.checked)}
                    disabled={!user.telegram_chat_id}
                    />    
            </td>
            <td>
                <Space>
                    {/* Avatar with green/gray dot */}
                    <div style={{ position: 'relative', display: 'inline-block' }}>
                        <Avatar
                            size={35}
                            src={user.image ? `${linkPath}${user.image}` : undefined}
                            icon={!user.image && <UserOutlined />}
                            style={{
                                backgroundColor: user.telegram_chat_id ? "#0088cc" : "#d9d9d9",
                                border: user.telegram_chat_id ? "2px solid #0088cc" : "1px solid #d9d9d9",
                            }}
                        />
                        {/* Connection status dot */}
                        <span style={{
                            position: 'absolute',
                            bottom: -2,
                            right: -2,
                            width: 12,
                            height: 12,
                            borderRadius: '50%',
                            backgroundColor: user.telegram_chat_id ? '#52c41a' : '#d9d9d9',
                            border: '2px solid #fff',
                            boxShadow: '0 0 0 1px rgba(0,0,0,0.1)',
                        }} 
                        title={user.telegram_chat_id ? 'បានភ្ជាប់ Telegram' : 'មិនទាន់ភ្ជាប់ Telegram'}
                        />
                    </div>
                    
                    {/* User info */}
                    <div style={{ display: "flex", flexDirection: "column" }}>
                        <span style={{ fontFamily: 'Content', fontWeight: "bold" }}>
                            {user.fullname}
                        </span>
                        <span style={{ fontSize: 12, color: "#888", fontFamily: 'Content' }}>
                            {user.position_kh || "N/A"}
                        </span>
                    </div>
                </Space>
            </td>
            <td style={{ fontFamily: 'Content' }}>{user.phone || user.username || "N/A"}</td>
            <td>
                {user.stafftype ? (
                    <Tag 
                        color={user.stafftype === 'រដ្ឋ' ? 'gold' : 'blue'} 
                        style={{ fontFamily: 'Content' }}
                    >
                        {user.stafftype}
                    </Tag>
                ) : (
                    <span style={{ color: "#999" }}>N/A</span>
                )}
            </td>
            <td style={{ fontFamily: 'Content' }}>{user.department_name || user.department || "N/A"}</td>
            <td>
                {user.telegram_chat_id ? (
                    <Tag color="#0088cc" style={{ fontFamily: 'Content' }}>
                        {user.telegram_chat_id}
                    </Tag>
                ) : (
                    <Tag color="default" style={{ fontFamily: 'Content' }}>
                        មិនទាន់ភ្ជាប់
                    </Tag>
                )}
            </td>
            <td>
              {user.telegram_chat_id ? (
    <Tag 
        icon={<CheckCircleOutlined />}
        color="success" 
        style={{ fontFamily: 'Content', padding: '2px 10px', borderRadius: '12px' }}
    >
        បានភ្ជាប់
    </Tag>
) : (
    <Tag 
        icon={<ClockCircleOutlined />}
        color="warning" 
        style={{ fontFamily: 'Content', padding: '2px 10px', borderRadius: '12px' }}
    >
        មិនទាន់ភ្ជាប់
    </Tag>
)}
            </td>
        </tr>
    ))}
    {usersArray.length === 0 && (
        <tr>
            <td colSpan={8} style={{ textAlign: "center", padding: "20px", fontFamily: 'Content' }}>
                មិនមានទិន្នន័យ
            </td>
        </tr>
    )}
</tbody>
            </table>
            
            <Pagination
              onChange={handlePageChange}
              size="large"
              current={currentPage}
              pageSize={itemsPerPage}
              total={total_item}
              style={{ marginTop: 16, textAlign: "right" }}
            />
          </>
        )}
      </div>

 {/* Send Message Modal */}
<Modal
    title={
        <Space>
            <BsTelegram style={{ color: "#0088cc", fontSize: 20 }} />
            <span style={{ fontFamily: 'Content' }}>ផ្ញើសារ Telegram</span>
        </Space>
    }
    className="styleTageStatusForm"
    open={visableNewModel}
    onCancel={() => {
        setVisableNewModel(false);
        handleRemoveAllFiles();
    }}
    width={700}
    footer={[
        <div key="footer">
            <Space>
                <Button onClick={() => {
                    setVisableNewModel(false);
                    handleRemoveAllFiles();
                }}>បោះបង់</Button>
                <Button
                    type="primary"
                    onClick={onSendMessage}
                    icon={<SendOutlined />}
                    disabled={(!messageText.trim() && uploadedFiles.length === 0) || selectedUsers.length === 0}
                >
                    ផ្ញើសារ ({selectedUsers.length} នាក់)
                </Button>
            </Space>
        </div>,
    ]}
>
    {/* Recipients */}
    <div style={{ marginBottom: "16px" }}>
        <div style={{ marginBottom: "8px" }}>
            <Space>
                <span style={{ fontFamily: 'Content', fontWeight: "bold" }}>អ្នកទទួលសារ:</span>
                <Tag color="blue" style={{ fontFamily: 'Content' }}>
                    {selectedUsers.length} នាក់
                </Tag>
            </Space>
        </div>
        <div style={{ maxHeight: "150px", overflowY: "auto", padding: "8px", border: "1px solid #d9d9d9", borderRadius: "4px" }}>
              {selectedUsers.length === 0 ? (
    <span style={{ color: "#999", fontFamily: 'Content' }}>មិនទាន់ជ្រើសរើសអ្នកទទួល</span>
  ) : (
    <Space wrap>
      {selectedUsers.map((item) => {
        const userInfo = getUserInfo(item);
        const userId = getUserId(item);
        return (
          <Tag
            key={userId}
            closable
            
            onClose={() => {
              setSelectedUsers(prev => 
                prev.filter(u => getUserId(u) !== userId)
              );
            }}
            style={{ 
              borderRadius:10,
              backgroundColor:'#0ba60337',
              color:'green',
              padding: "4px", 
              fontWeight:'bold',
              fontFamily: 'Content',
              display: 'inline-flex',
              alignItems: 'center',
              gap: '3px'
            }}
            icon={
              <Avatar
                size={20}
                src={userInfo?.image ? `${linkPath}${userInfo.image}` : undefined}
                icon={!userInfo?.image && <UserOutlined />}
                style={{ 
                  backgroundColor: userInfo?.telegram_chat_id ? '#0088cc' : '#d9d9d9'
                }}
              />
            }
          >
            {userInfo?.fullname || userId}
          </Tag>
        );
      })}
    </Space>
  )}
        </div>
    </div>

    {/* Message Type */}
    <div style={{ marginBottom: "16px" }}>
        <div style={{ marginBottom: "8px", fontFamily: 'Content', fontWeight: "bold" }}>ប្រភេទសារ:</div>
        <Select
            value={messageType}
            onChange={(value) => {
                setMessageType(value);
                if (value === 'text') {
                    handleRemoveAllFiles();
                }
            }}
            style={{ width: "100%" }}
            className="styleTageStatusForm"
        >
            <Option value="text">សារអត្ថបទ (Text Only)</Option>
            <Option value="media">រូបភាព + ឯកសារ + អត្ថបទ (Image + File + Caption)</Option>
            <Option value="attendance_report">របាយការណ៍វត្តមាន</Option>
        </Select>
    </div>

    {/* File Upload (shown when type is 'media') */}
    {messageType === 'media' && (
        <div style={{ marginBottom: "16px" }}>
            <div style={{ marginBottom: "8px", fontFamily: 'Content', fontWeight: "bold" }}>
                ឯកសារភ្ជាប់ ({uploadedFiles.length}/10):
            </div>
            
            {/* File List with Previews */}
            {uploadedFiles.length > 0 && (
                <div style={{ 
                    display: 'flex', 
                    flexDirection: 'column',
                    gap: '6px', 
                    marginBottom: '12px',
                    padding: '8px',
                    background: '#fafafa',
                    borderRadius: '8px',
                    border: '1px solid #f0f0f0',
                    maxHeight: '250px',
                    overflowY: 'auto'
                }}>
                    {uploadedFiles.map((item, index) => (
                        <div 
                            key={index} 
                            style={{ 
                                display: 'flex',
                                alignItems: 'center',
                                gap: '10px',
                                padding: '8px 12px',
                                background: '#fff',
                                borderRadius: '6px',
                                border: '1px solid #e8e8e8'
                            }}
                        >
                            {/* File Number */}
                            <span style={{
                                background: '#1890ff',
                                color: '#fff',
                                borderRadius: '50%',
                                width: 22,
                                height: 22,
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                fontSize: 11,
                                fontWeight: 'bold',
                                flexShrink: 0
                            }}>
                                {index + 1}
                            </span>
                            
                            {/* Image Preview or File Icon */}
                            {item.isImage ? (
                                <img 
                                    src={item.preview} 
                                    alt={item.name}
                                    style={{ 
                                        width: 40, 
                                        height: 40, 
                                        borderRadius: 4, 
                                        objectFit: 'cover',
                                        border: '1px solid #eee',
                                        flexShrink: 0
                                    }}
                                />
                            ) : (
                                <div style={{
                                    width: 40,
                                    height: 40,
                                    borderRadius: 4,
                                    background: getFileColor(item.extension),
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    flexShrink: 0
                                }}>
                                    <span style={{ 
                                        color: '#fff', 
                                        fontSize: 14, 
                                        fontWeight: 'bold',
                                        textTransform: 'uppercase'
                                    }}>
                                        {item.extension || 'FILE'}
                                    </span>
                                </div>
                            )}
                            
                            {/* File Info */}
                            <div style={{ flex: 1, minWidth: 0 }}>
                                <div style={{ 
                                    fontFamily: 'Content', 
                                    fontSize: 13, 
                                    fontWeight: 500,
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                    whiteSpace: 'nowrap'
                                }}>
                                    {item.name}
                                </div>
                                <div style={{ fontSize: 11, color: '#888' }}>
                                    {formatFileSize(item.size)}
                                    {item.isImage && <Tag color="green" style={{ marginLeft: 6, fontSize: 10, padding: '0 4px' }}>រូបភាព</Tag>}
                                    {!item.isImage && <Tag color="blue" style={{ marginLeft: 6, fontSize: 10, padding: '0 4px' }}>ឯកសារ</Tag>}
                                </div>
                            </div>
                            
                            {/* Remove Button */}
                            <Button
                                type="text"
                                danger
                                size="small"
                                icon={<DeleteOutlined />}
                                onClick={() => handleRemoveFile(index)}
                                style={{ flexShrink: 0 }}
                            />
                        </div>
                    ))}
                </div>
            )}
            
            {/* Upload Button */}
            {uploadedFiles.length < 10 && (
                <Upload
                    beforeUpload={handleFileUpload}
                    showUploadList={false}
                    accept="image/*,.pdf,.doc,.docx,.ppt,.pptx,.xls,.xlsx,.txt,.csv,.zip,.rar"
                    multiple={true}
                >
                    <Button 
                        icon={<UploadOutlined />} 
                        style={{ fontFamily: 'Content' }}
                    >
                        ជ្រើសរើសឯកសារ
                    </Button>
                    <span style={{ marginLeft: 8, fontSize: 12, color: '#888', fontFamily: 'Content' }}>
                        (អតិបរមា 10 ឯកសារ | រូបភាព, PDF, Word, Excel, PPT...)
                    </span>
                </Upload>
            )}
        </div>
    )}

    {/* Text Message */}
    <div>
        <div style={{ marginBottom: "8px", fontFamily: 'Content', fontWeight: "bold" }}>
            {messageType === 'media' ? 'ចំណងជើង (Caption):' : 'ខ្លឹមសារសារ:'}
        </div>
        <TextArea
            value={messageText}
            style={{ height: messageType === 'media' ? 80 : 200 }}
            onChange={(e) => setMessageText(e.target.value)}
            className="styleTageStatusForm"
            rows={messageType === 'media' ? 3 : 12}
            placeholder={messageType === 'media' ? "បញ្ចូលចំណងជើង (ជាជម្រើស)..." : "បញ្ចូលសារដែលអ្នកចង់ផ្ញើ..."}
            showCount
            maxLength={messageType === 'media' ? 1024 : 4096}
        />
        <div style={{ marginTop: "8px", fontSize: "12px", color: "#888", fontFamily: 'Content' }}>
            តួអក្សរ: {messageText.length}/{messageType === 'media' ? 1024 : 4096}
        </div>
    </div>
</Modal>

      {/* Message History Modal */}
      <Modal
        title={
          <Space>
            <HistoryOutlined />
            <span style={{ fontFamily: 'Content' }}>ប្រវត្តិសារដែលបានផ្ញើ</span>
          </Space>
        }
        className="styleTageStatusForm"
        open={visableHistoryModel}
        onCancel={() => setVisableHistoryModel(false)}
        width={900}
        footer={null}
      >
       <Table
    columns={messageColumns}
    dataSource={messagesArray}
    rowKey="id"
    pagination={{ pageSize: 10 }}
    size="small"
    expandable={{
        expandedRowRender: (record) => (
            <div style={{ padding: '12px 16px', background: '#fafafa', borderRadius: 4 }}>
                <div style={{ fontFamily: 'Content', fontWeight: 'bold', marginBottom: 12, fontSize: 14 }}>
                    <MessageFilled /> បញ្ជីអ្នកទទួលសារ ({record.recipients?.length || 0} នាក់)
                </div>
                <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                    <thead>
                        <tr style={{ background: '#e6f7ff' }}>
                            <th style={{ padding: '6px 12px', width: 50 }}></th>
                            <th style={{ padding: '6px 12px', textAlign: 'left', fontFamily: 'Content', fontSize: 12 }}>ឈ្មោះ</th>
                            <th style={{ padding: '6px 12px', textAlign: 'left', fontFamily: 'Content', fontSize: 12 }}>លេខទូរស័ព្ទ</th>
                            <th style={{ padding: '6px 12px', textAlign: 'left', fontFamily: 'Content', fontSize: 12 }}>Telegram ID</th>
                            <th style={{ padding: '6px 12px', textAlign: 'center', fontFamily: 'Content', fontSize: 12 }}>ស្ថានភាព</th>
                        </tr>
                    </thead>
                    <tbody>
                        {record.recipients?.map((r, i) => (
                            <tr key={i} style={{ borderBottom: '1px solid #f0f0f0' }}>
                                <td style={{ padding: '6px 12px', textAlign: 'center' }}>
                                    <Avatar
                                        size={30}
                                        src={r.image ? `${linkPath}${r.image}` : undefined}
                                        icon={!r.image && <UserOutlined />}
                                        style={{ backgroundColor: '#0088cc' }}
                                    />
                                </td>
                                <td style={{ padding: '6px 12px', fontFamily: 'Content', fontSize: 12 }}>
                                    {r.fullname || 'Unknown'}
                                </td>
                                <td style={{ padding: '6px 12px', fontFamily: 'Content', fontSize: 12 }}>
                                    {r.phone || '-'}
                                </td>
                                <td style={{ padding: '6px 12px', fontSize: 11, color: '#0088cc' }}>
                                    {r.chat_id}
                                </td>
                                <td style={{ padding: '6px 12px', textAlign: 'center' }}>
                                    <Badge status={r.status === 'sent' ? 'success' : 'error'} />
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        ),
    }}
/>
      </Modal>
    </div>
  );
};

export default SendMessageTelegram;